export const TEST = 'TEST';
export const AUTHENTICATION_INITIAL_STATE = 'AUTHENTICATION_INITIAL_STATE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_PENDING = 'LOGIN_PENDING';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const REGISTRATION_PENDING = 'REGISTRATION_PENDING';
export const REGISTRATION_ERROR = 'REGISTRATION_ERROR';
export const LOGOUT = 'LOGOUT';
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_PENDING = 'AUTHENTICATION_PENDING';
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';
export const USER_LIBRARY = 'USER_LIBRARY';
export const DEFAULT_ROLE = 'DEFAULT_ROLE';
export const UPDATE_LIBRARY_SUCCESS = 'UPDATE_LIBRARY_SUCCESS';
export const UPDATE_LIBRARY_ERROR = 'UPDATE_LIBRARY_ERROR';
export const TEAM_MEMBER_ADD = 'TEAM_MEMBER_ADD';
export const GET_TEAM_MEMBER = 'GET_TEAM_MEMBER';
export const TEAM_GET = 'TEAM_GET';
export const ADD_TIME_SLOT = 'ADD_TIME_SLOT';
export const BOOKING_TIME_SLOT = 'BOOKING_TIME_SLOT';
export const BOOKED_TIME = 'BOOKED_TIME';
export const FETCH_USERS = 'FETCH_USERS';
export const UPDATE_USERS = 'UPDATE_USERS';
export const UPDATE_USERS_ERROR = 'UPDATE_USERS_ERROR';
export const PUBLIC_LIBRARIES = 'PUBLIC_LIBRARIES';
export const PUBLIC_TEAMS = 'PUBLIC_TEAMS';
export const PROGRAM = "PROGRAM";
export const UPDATE_PROGRAM ="UPDATE_PROGRAM";
export const FETCH_CLASS ="FETCH_CLASS";
export const UPDATE_CLASS = "UPDATE_CLASS";
export const BOOKING_TIME_SLOT_ERROR= "BOOKING_TIME_SLOT_ERROR";
export const FETCH_COACHES = "FETCH_COACHES";
export const CHANGE_PASSWORD= "CHANGE_PASSWORD";
export const FORGOT_PASSSWORD= "FORGOT_PASSSWORD";